import React from 'react';

const MobileMenu = ({ menus, activeDropdowns, toggleSideMenu, toggleDropdown }) => {
    return (
        <div className="mobilemenu js-push-mbmenu" onClick={toggleSideMenu}>
            <div className="mobilemenu-content" onClick={(e) => e.stopPropagation()}>
                <div className="mobilemenu-close mobilemenu-toggle" onClick={toggleSideMenu}>
                    Close
                </div>
                <div className="mobilemenu-scroll">
                    <div className="mobilemenu-search" />
                    <div className="nav-wrapper show-menu"></div>
                    <div className="mobilemenu-bottom">
                        {menus.map(el => (
                            <div className="mobilemenu-currency" key={el.id}>
                                <div className="dropdn_currency">
                                    <div className="dropdn dropdn_caret">
                                        <a href={el.url} className="dropdn-link js-dropdn-link">
                                            {el.label}
                                            {(el.second_level && el.second_level.length > 0) && (
                                                <span className="arrow" onClick={(e) => { 
                                                    e.preventDefault(); 
                                                    toggleDropdown(el.id); 
                                                }}>
                                                    <i className="icon-angle-down" />
                                                </span>
                                            )}
                                        </a>
                                        {(el.second_level && el.second_level.length > 0) && (
                                            <div className={`dropdn-content ${activeDropdowns.includes(el.id) ? 'show' : 'hidden'}`}>
                                                <ul>
                                                    {el.second_level.map(second_level => (
                                                        <li key={second_level.id}>
                                                            <a href={second_level.url}>
                                                                <span>{second_level.label}</span>
                                                                {(second_level.third_level && second_level.third_level.length > 0) && (
                                                                    <span className="arrow" onClick={(e) => { 
                                                                        e.preventDefault(); 
                                                                        toggleDropdown(second_level.id); 
                                                                    }}>
                                                                        <i className="icon-angle-down" />
                                                                    </span>
                                                                )}
                                                            </a>
                                                            {second_level.third_level && second_level.third_level.length > 0 && (
                                                                <div className={`dropdn-content ${activeDropdowns.includes(second_level.id) ? 'show' : 'hidden'}`}>
                                                                    <ul className="nav-level-3">
                                                                        {second_level.third_level.map(third_level => (
                                                                            <li key={third_level.id}><a href={third_level.url}>{third_level.label}</a></li>
                                                                        ))}
                                                                    </ul>
                                                                </div>
                                                            )}
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MobileMenu;
